import { linkToMonitoringPage } from "../../links";

export function linkToMonitoringOverviewPage() {
  return `${linkToMonitoringPage()}/overview`;
}
